import { styled as t, Box as m } from "@mui/material";
import s from "../../../assets/icons/icon-blank.svg.js";
import { SkeletonTypography as f } from "./Skeleton.js";
import p from "../next/Image.js";
import { Trans as x } from "react-i18next";
import { jsxs as d, jsx as o } from "react/jsx-runtime";
const h = t(m)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 5px;
`, n = t(p)`
  aspect-ratio: 1;
  width: 40px;
`, g = t(f)`
  flex: 1;
  font-size: 14px;
  font-weight: 300;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  strong {
    color: #ffcc00;
    font-size: 20;
    font-weight: 500;
  }
`, C = (c) => {
  const {
    className: i,
    endSrc: e,
    loading: a,
    startSrc: r,
    text: l
  } = c;
  return /* @__PURE__ */ d(h, {
    className: i,
    children: [r && /* @__PURE__ */ o(n, {
      className: "Custom-Icon",
      src: r || s
    }), /* @__PURE__ */ o(g, {
      className: "Custom-Text",
      loading: a,
      children: /* @__PURE__ */ o(x, {
        children: l
      })
    }), e && /* @__PURE__ */ o(n, {
      className: "Custom-Icon",
      src: e || s
    })]
  });
};
export {
  C as default
};
//# sourceMappingURL=IconText.js.map
